export default __webpack_public_path__ + "static/media/layer2.518433c9.svg";